import { NEOCALCUL_HERO_COPY } from '../neocalculLanding';

/** NeoCalcul landing on calcul.neoprof.fr (LAND5 v2 step 3): head, angles, tutor CTA. */
export const NEOCALCUL_LANDING_COPY = Object.freeze({
  eyebrow: 'NeoCalcul',
  send: 'Envoyer une série à mon élève',
  tutorBand: Object.freeze({
    title: 'Tu es prof particulier ?',
    body: 'Envoie une série de calcul à ton élève, sans compte, et reçois son rapport.',
    link: 'Découvrir NeoCalcul',
  }),
  seo: Object.freeze({
    title: 'NeoCalcul — séries de calcul gratuites pour ton élève',
    description: 'Règle une série de calcul en quelques clics et envoie son lien à ton élève : il s’entraîne sans compte, tu reçois son rapport. Gratuit.',
    answer: 'NeoCalcul est une station de calcul gratuite : le professeur règle une série (classe, notions, niveau), l’élève la joue depuis un lien sans compte, et le professeur reçoit son rapport.',
    applicationName: 'NeoCalcul',
    home: 'Accueil',
    imageAlt: 'NeoCalcul, la station de calcul de NeoProf',
  }),
});

/** `?k=` angles: each swaps the hero title only. `rituel` is the validated title. */
export const NEOCALCUL_LANDING_ANGLES = Object.freeze({
  rituel: Object.freeze({ title: NEOCALCUL_HERO_COPY.title, titleEm: NEOCALCUL_HERO_COPY.titleEm }),
  devoirs: Object.freeze({ title: 'Des devoirs de calcul que ton élève ', titleEm: 'fait vraiment.' }),
  rapport: Object.freeze({ title: 'Ton élève s’entraîne chez lui. ', titleEm: 'Tu reçois son rapport.' }),
});
